import React from 'react';
import classNames from 'classnames';

import linkedInLogo from '../../assets/linkedin-logo.png';

import config from '../../config';
import { goTo, get3rdPartyRedirectUri } from '../../utils';

const { linkedInID } = config;

interface Props {
  eventId: string;
  type: 'sign-up' | 'login' | 'check-in';
  widthClass: string;
}

const LinkedInBtn: React.FC<Props> = (props) => {
  const { eventId, type, widthClass } = props;

  const url =
    'https://www.linkedin.com/oauth/v2/authorization' +
    `?response_type=code&client_id=${linkedInID}` +
    `&redirect_uri=${get3rdPartyRedirectUri('linkedin', type, true)}` +
    `&state=${eventId}` +
    '&scope=profile%20openid%20email';

  return (
    <button
      onClick={() => goTo(url)}
      className={classNames(
        widthClass,
        { 'w-full': !widthClass },
        'h-10 flex items-center text-sm text-white bg-[#0077b5] rounded-[0.25rem] border-2 border-transparent overflow-hidden hover:bg-[#0369a0] transition-colors duration-200',
      )}
    >
      <img
        src={linkedInLogo}
        alt="LinkedIn Logo"
        className="h-full bg-[#0077b5] border-r border-[#0369a0] border-solid"
      />
      <div className="w-full px-3 text-center font-medium whitespace-nowrap overflow-hidden text-ellipsis">
        Continue with LinkedIn
      </div>
    </button>
  );
};

export default LinkedInBtn;
